import React from 'react';
import {addFreeformChoiceText} from '../addFreeformChoiceText';
import {LessonContentFreeformTextChoice} from '../../../../data/models/LessonContent/LessonContentBase';
import TextAreaInput from '../../../../uiToolkit/Inputs/TextAreaInput';

interface Props {
  textNode: LessonContentFreeformTextChoice;
  onChangeTextField: (field: string, value: any) => void;
}

const FreeformTextOptions = React.memo(
  ({textNode, onChangeTextField}: Props) => {
    return (
      <div className="OptionsContainer">
        <p className="SectionHeader">{addFreeformChoiceText.options}</p>
        <div className="OptionsContent">
          <TextAreaInput
            value={textNode.text}
            heading={addFreeformChoiceText.freeformTextInput}
            onChange={(value: string) =>
              onChangeTextField('text', value.trimStart())
            }
            placeholder={addFreeformChoiceText.title}
            uiType="box"
            className="OptionsInput"
            maxCharacters={200}
          />
        </div>
      </div>
    );
  },
);

export default FreeformTextOptions;
